export const styleTypeProps = {
    primary: {
        mainBarColor: "#6745F1",
        secondaryBarColor: "#C2B5F9",
        backgroundColor: "transparent",
        gap: 1,
        rounded: 4,
        barWidth: 3
    }
};
